<template>

<div class="divide"></div>    

</template>

<script>

export default {
    
}

</script>

<style scoped>

.divide {
    height: 1px;
    background-color: var(--color-grey-light);
    margin: 5px 0px 8px 0px;
}

</style>